/**
 * Gender codes as delivered by the streaming API (TMDB convention).
 *
 * The API changed the field from an integer to a string, so the values are
 * kept as strings here and callers should compare against this enum instead
 * of against numeric literals.
 */
export enum PersonGender {
  NotSpecified = '0',
  Female = '1',
  Male = '2',
  NonBinary = '3',
  NotApplicable = '4',
}

const genderLabels: Record<PersonGender, string | null> = {
  [PersonGender.NotSpecified]: null,
  [PersonGender.Female]: 'Weiblich',
  [PersonGender.Male]: 'Männlich',
  [PersonGender.NonBinary]: 'Divers',
  [PersonGender.NotApplicable]: null,
};

/**
 * Maps a raw gender value to its German label.
 *
 * Accepts numbers as well, so responses that still deliver the legacy integer
 * keep working. Returns `null` when there is nothing meaningful to display
 * (not specified, not applicable, missing or unknown code) — render the field
 * conditionally on that.
 */
export const getGenderLabel = (gender?: string | number | null): string | null => {
  if (gender === null || gender === undefined || gender === '') return null;

  return genderLabels[String(gender) as PersonGender] ?? null;
};
